import { render, staticRenderFns } from "./MarketsVG.vue?vue&type=template&id=2f05b949"
import script from "./MarketsVG.vue?vue&type=script&lang=js"
export * from "./MarketsVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports